export const PLATFORM_FEE_TYPES = {
  ASK_CLIENT_TO_PAY: 'ASK_CLIENT_TO_PAY',
  BUSINESS_PAYS: 'BUSINESS_PAYS',
  CLIENT_PAYS: 'CLIENT_PAYS',
  ASK_CLIENT_TO_PAY_SPLIT: 'ASK_CLIENT_TO_PAY_SPLIT',
  CLIENT_PAYS_SPLIT: 'CLIENT_PAYS_SPLIT',
};
